const React = require('react');
const {getRFC3339} = require('mn-utils/formatTime');
const EditIcon = require('@material-ui/icons/Edit').default;
const IconButton = require('@material-ui/core/IconButton').default;

const formatTime = require('../../../../../../../../utils/formatTime');
const RowA = require('../../../../../../../dumb/Row/A');
const ColA = require('../../../../../../../dumb/Col/A');
const Tooltip = require('../../../../../../../dumb/Tooltip/A');
const EllipsisMiddle = require('../../../../../../../dumb/EllipsisMiddle');

const {statusesNames} = require('../../../../constants/statuses');
const openEditPopup = require('./utils/openEditPopup');
const formatCCSymbol = require("../../../../../../../../utils/formatCCSymbol");
const formatNumCoin = require("../../../../../../../../utils/formatNumCoin");
const {
  DisplayDataAdmin,
  DisplayIdAdmin,
  DisplayAddressAdmin,
  DisplayAmountAdmin,
  DisplayDateTimeAdmin
} = require("../../../../../../../dumb/DisplayData");
const {AdminTimeCell} = require("../../../../../../../dumb/TableTimeCell");
const {TableNumberColAmin} = require("../../../../../../../dumb/TableNumberCol");

module.exports = ({data, update}) => {
  const id = data.id || '';
  const orderId = data.order_id || '';
  const transactionId = data.tx_id || '';
  const fiatAmount = data.fiat_amount || '';
  const fiatCode = data.fiat_code || '';
  const fiat = `${fiatAmount} ${fiatCode}`;
  const assetAmount = data.asset_amount || '';
  const assetCode = data.asset_code || '';
  const status = data.life_flow || '';
  const createdAt = data.created_at || '';
  const address = data.to_address || null;
  const addressTag = data.to_address_tag || null;
  const exchange = data.exchange_type || '';
  // const merchantId = data.merchant_id || '';
  const merchantName = data.merchant_name || '';
  const merchantEmail = data.merchant_email || '';

  return (
    <div className="dB w olN tdN cF dn bgF1:h">
      <RowA className="f12">
        <ColA className="wmin155 fx1">
          <DisplayIdAdmin>{id}</DisplayIdAdmin>
        </ColA>
        <ColA className="wmin200 fx1">
          <DisplayDataAdmin>{merchantName || merchantEmail}</DisplayDataAdmin>
        </ColA>
        <ColA className="wmin155 fx1">
          <DisplayIdAdmin>{orderId}</DisplayIdAdmin>
        </ColA>
        <ColA className="wmin150 fx1">
          <DisplayAddressAdmin>
            {address}
          </DisplayAddressAdmin>
          {address && addressTag ? (
            <DisplayDataAdmin className="dB cCC mt5">
              tag: {addressTag}
            </DisplayDataAdmin>
          ) : null}
        </ColA>
        <ColA className="wmin130 fx1">
          <DisplayAmountAdmin
            amount={fiatAmount}
            symbol={fiatCode}
            type="fiat"
          />
        </ColA>
        <ColA className="wmin130 fx1">
          <DisplayAmountAdmin
            amount={assetAmount}
            symbol={formatCCSymbol(assetCode)}
            type="coin"
          />
        </ColA>
        <ColA className="wmin130 fx1">
          <DisplayDataAdmin>
            {exchange}
          </DisplayDataAdmin>
        </ColA>
        <ColA
          className={`wmin140 fx1 tc c9259CA.ready_for_withdraw
              c59CACA.requested_by_merchant cCAC359.approved_by_buyer
              c82CA59.refund_done cCA5959.failed cCA5959.cancelled ${status}`}
        >
          <Tooltip>{statusesNames[status]}</Tooltip>
        </ColA>
        <ColA className="wmin95">
          <DisplayDateTimeAdmin
            date={createdAt}
          />
        </ColA>
        <ColA className="w70">
          <IconButton
            className="olN-i"
            onClick={openEditPopup({id, transactionId, assetAmount, update})}
          >
            <div className="sq23 layoutRow fhaC fvaC cF">
              <EditIcon/>
            </div>
          </IconButton>
        </ColA>
      </RowA>
    </div>
  );
};
